import React, { useEffect, useState } from "react";
import { TextField, Autocomplete } from "@mui/material"; 
import axiosInstance from "../../Service/axiosInstance";

const ListePays = ({ selectedCountry, onSelectCountry }) => {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axiosInstance
            .get("/yourtravelshop/pays/liste")
            .then((response) => {
                setCountries(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Erreur lors de la récupération des pays :", error);
                setLoading(false);
                setError("Erreur de chargement des pays.");
            });
    }, []);

    return (
        <Autocomplete
            value={selectedCountry}
            onChange={(event, newValue) => {
                const country = newValue ? { id: newValue.idPays, nom: newValue.nom } : null;
                onSelectCountry(country);
            }}
            options={countries}
            getOptionLabel={(option) => option.nom || ""}
            isOptionEqualToValue={(option, value) => option.idPays === value.id}
            renderOption={(props, option) => (
                <li {...props} key={option.idPays}>
                    {option.nom}
                </li>
            )}
            renderInput={(params) => (
                <TextField
  {...params}
  label="Pays d'origine"
  variant="outlined"
  fullWidth
  required
  error={!!error}
  helperText={error}
  InputLabelProps={{
    style: { color: "grey" }
  }}
  sx={{
    input: {
      color: 'black',            // Texte saisi en noir
      backgroundColor: 'white'   // Fond du champ (input) en blanc
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',  // Fond de l'input en blanc
      '& fieldset': {
        borderColor: 'grey'
      },
      '&:hover fieldset': {
        borderColor: 'black'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black'
      }
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'black'                 },
    '& .MuiFormHelperText-root': {
      color: 'red'                }
  }}
/>            )}
            filterOptions={(options, state) =>
                options.filter(option =>
                    option.nom.toLowerCase().includes(state.inputValue.toLowerCase())
                )
            }
            loading={loading}
        />
    );
};

export default ListePays;
